import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import useWindowDimensions from '../../../../_gori/hooks/useWindowDimensions'
import {Button} from '../../../../_gori/partials/widgets'

type TutorialType = 'ref4' | 'qr'

const TUTORIALS: Record<TutorialType, {titleKey: string; media: string; descKey: string}> = {
  ref4: {
    titleKey: 'GORI_SIGNATURE_TUTORIAL_REF4_TITLE',
    media: 'https://gori-ai.s3.us-west-2.amazonaws.com/shipbae-assets/gori_signature/ref4.gif',
    descKey: 'GORI_SIGNATURE_TUTORIAL_REF4_DESC',
  },
  qr: {
    titleKey: 'GORI_SIGNATURE_TUTORIAL_QR_TITLE',
    media: 'https://gori-ai.s3.us-west-2.amazonaws.com/shipbae-assets/gori_signature/qr.gif',
    descKey: 'GORI_SIGNATURE_TUTORIAL_QR_DESC',
  },
}

const MOBILE_BREAKPOINT = 768

// Popup modal — triggered by clicking inline links
type ModalProps = {
  show: boolean
  type: TutorialType
  handleClose: () => void
}

const TutorialModal: React.FC<ModalProps> = ({show, type, handleClose}) => {
  const intl = useIntl()
  const tutorial = TUTORIALS[type]

  return (
    <Modal
      className='gori-signature-tutorial'
      id='gori_signature_tutorial_modal'
      tabIndex={-1}
      aria-labelledby='gori_signature_tutorial_title'
      centered
      dialogClassName='modal-size-md h-auto'
      contentClassName='modal-padding'
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id='gori_signature_tutorial_title' bsPrefix='fw-bolder fs-1'>
          {intl.formatMessage({id: tutorial.titleKey})}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img
          key={type}
          src={tutorial.media}
          alt={intl.formatMessage({id: tutorial.titleKey})}
          className='gori-signature-tutorial__media'
        />
        <div className='gori-signature-tutorial__desc'>
          {intl.formatMessage({id: tutorial.descKey})}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className='btn btn-advanced-secondary'
          label={intl.formatMessage({id: 'CLOSE'})}
          event={handleClose}
        />
      </Modal.Footer>
    </Modal>
  )
}

// Fixed bottom-left help widget — desktop only, auto-shows with Ref 4 content
type PanelProps = {
  show: boolean
  handleClose: () => void
}

const TutorialPanel: React.FC<PanelProps> = ({show, handleClose}) => {
  const {width} = useWindowDimensions()
  const intl = useIntl()

  if (!show || width <= MOBILE_BREAKPOINT) return null

  return (
    <div className='gori-signature-tutorial__fixed'>
      <div className='gori-signature-tutorial__card'>
        <img
          src={TUTORIALS.ref4.media}
          alt={intl.formatMessage({id: TUTORIALS.ref4.titleKey})}
          className='gori-signature-tutorial__media'
        />
        <div className='gori-signature-tutorial__subtitle'>
          {intl.formatMessage({id: 'GORI_SIGNATURE_TUTORIAL_REF4_SUBTITLE'})}
        </div>
        <div className='gori-signature-tutorial__desc'>
          {intl.formatMessage({id: TUTORIALS.ref4.descKey})}
        </div>
        <div className='gori-signature-tutorial__footer'>
          <Button
            className='btn gori-signature-tutorial__btn-panel'
            label={intl.formatMessage({id: 'CLOSE'})}
            event={handleClose}
          />
        </div>
      </div>
    </div>
  )
}

export {TutorialModal, TutorialPanel}
export type {TutorialType}
